import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";


import { Header } from "../../components/header/header";
import { Footer } from "../../components/footer/footer";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useAuthentication } from "../../services/authentication/authentication.context";
import "../../styles/form.css";
import { AppLoader } from "../../components/utilities/loading";



export const UserLogin = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [masked, setMasked] = useState(true);

    

    const [invalidData, setInvaliData] = useState([]);

    const { signInUser, isLoading } = useAuthentication();

    const isInvalid = (d) => {
        return d === '' || d === null || d === undefined;
    }
    const validateData = () => {
        if (isInvalid(email)) {
            setInvaliData((d) => ([...d, "email"]));
        } else {
            setInvaliData((d) => d.filter((k) => k !== 'email'));
        }

        if (isInvalid(password)) {
            setInvaliData((d) => ([...d, "password"]));
        } else {
            setInvaliData((d) => d.filter((k) => k !== "password"));
        }
    }



    return (
        <div className="rand-page">
            <Header pageTitle={"Login"} />
            {isLoading && <AppLoader />}
            <div className="form-body">
                <form className="auth-form glassy-effect">
                    <div
                        className={classNames(
                            "auth-input-box",
                            { "invalid": invalidData.includes("email") }
                        )}
                    >
                        <FontAwesomeIcon icon={faUserAlt} className="input-ico" />
                        <input
                            type="email"
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            placeholder="Email or username"
                        />
                    </div>
                    <div
                        className={classNames(
                            "auth-input-box",
                            { "invalid": invalidData.includes("password") }
                        )}
                    >
                        <FontAwesomeIcon icon={faKey} className="input-ico" />
                        <input
                            type={masked ? "password": "text"}
                            name="password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            placeholder="password"
                        />
                        <button
                            className="tr-btn eye-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                setMasked((v) => !v)
                            }}
                        >
                            <FontAwesomeIcon
                                icon={masked ? faEye : faEyeSlash}
                                className="input-ico"
                            />
                        </button>
                    </div>

                    <button
                        className="form-submit"
                        onClick={async (e) => {
                            e.preventDefault();
                            validateData();
                            if (invalidData.includes('email') || invalidData.includes('password')) {
                                return;
                            }
                            const resp = await signInUser(email, password);
                            if (resp?.error){
                                alert(resp?.error);
                            }else{
                                window.location.href = "/randadmin";
                            }
                        }}
                    >
                        Sign in
                    </button>
                </form>
            </div>
            <Footer />
        </div>
    )
}